<template>
  <!-- <a-drawer
    :title="title"
    :width="width"
    :closable="false"
    @close="close"
    :visible="visible"> -->
  
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    @close="close"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <!-- <a-form-item label="人员名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-popup
            v-decorator="['workerName', validatorRules.workerName]"
            :trigger-change="true"
            org-fields="realname,username"
            dest-fields="workerName,workerNo"
            code="user_msg"
            @callback="handleAddUserRole"/>
        </a-form-item> -->
        <a-form-item label="人员名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'workerName', validatorRules.workerName]" placeholder="请输入人员名称" disabled="disabled"></a-input>
        </a-form-item>
        <a-form-item label="人员角色" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['workerRole', validatorRules.workerRole]" :trigger-change="true" dictCode="standard_team_worker_role" placeholder="请选择人员角色"/>
        </a-form-item>
        <a-form-item label="禁用状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="radio" v-decorator="['delFlag', validatorRules.delFlag]" :trigger-change="true" dictCode="del_flag" placeholder="请选择禁用状态"/>
        </a-form-item>
        <a-form-item label="人员工号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'workerNo', validatorRules.workerNo]" placeholder="请输入人员工号" disabled="disabled"></a-input>
        </a-form-item>
        
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction, postAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  
  export default {
    name: "GroupMemberModal",
    components: { 
      JDictSelectTag,
    },
    props:[
      'groupId'
    ],
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          workerName: {rules: [
            {required: true, message: '请输入人员名称!'},
          ]},
          workerRole: {rules: [
            {required: true, message: '请输入人员角色!'},
          ]},
          delFlag: {rules: [
            {required: true, message: '请输入禁用状态!'},
          ]},
          workerNo: {rules: [
          ]},
        },
        url: {
          add: "/standardTeam/worker/add",
          edit: "/standardTeam/worker/edit",
          list2: '/sys/user/userRoleList',
        },
      }
    },
    created () {

    },
    methods: {
       handleAddUserRole() {
         console.log(111111)
        if (this.currentRoleId == '') {
          this.$message.error('请选择一个角色!')
        } else {
          this.$refs.selectUserModal.visible = true
        }
      },
      selectOK(data) {
        let params = {}
        params.roleId = this.currentRoleId
        params.userIdList = []
        for (var a = 0; a < data.length; a++) {
          params.userIdList.push(data[a])
        }
        console.log(params)
        postAction(this.url.addUserRole, params).then((res) => {
          if (res.success) {
            this.loadData2()
            this.$message.success(res.message)
          } else {
            this.$message.warning(res.message)
          }
        })
      },
      loadData2(arg) {
        if (!this.url.list2) {
          this.$message.error('请设置url.list2属性!')
          return
        }
      },
      add () {
        this.edit({});
      },
      edit (record) {
        console.log('record',record)
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'id','workerName','groupId','workerRole','delFlag','workerNo'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            formData.groupId = this.groupId
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('editMemberOk');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'id','workerName','groupId','workerRole','delFlag:1','workerNo'))
      }
      
    }
  }
</script>

<style lang="less" scoped>
/** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
</style>